import { Form, Input, Select } from 'antd';
import { InputInterface } from '../utils/forms/FormInterface';
import { COUNTRY_CODE } from '../constants/EntityName';
import './style.scss';

const { Option } = Select;

export interface PhoneInputProps {
  formInput: InputInterface;
  index: number;
  form?: any;
  additionalData?: any;
}

const PhoneInput = (props: PhoneInputProps) => {
  const { formInput, index, form, additionalData } = props;

  // Get country codes from additionalData
  const countryCodeList = additionalData?.[COUNTRY_CODE]?.data || [];

  return (
    <Form.Item
      key={index}
      wrapperCol={{ span: 8, offset: 4 }}
      labelCol={{ span: 4 }}
      label={<div className={!formInput.required ? 'leftOffset' : ''}>{formInput.label}</div>}
      colon={formInput.required}
      labelAlign="left"
      rules={[
        {
          required: formInput.required,
          message: formInput.errorMsg,
        },
        ...((formInput.rules ? formInput.rules : []) as Array<any>),
      ]}
    >
      <Input.Group compact style={{ display: 'flex' }}>
        <Form.Item
          name="countryCode"
          noStyle
          rules={[
            {
              required: formInput.required,
              message: 'Country code is required',
            },
          ]}
        >
          <Select
            style={{ width: '30%', minWidth: '120px' }}
            placeholder="Code"
            showSearch
            optionFilterProp="children"
            disabled={formInput.readonly}
            dropdownClassName="select-checkbox-dropdown"
          >
            {countryCodeList.map((item: { code: string; name: string }) => (
              <Option key={item.code} value={item.code}>
                {item.code} {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name={formInput.name}
          noStyle
          rules={[
            {
              required: formInput.required,
              message: formInput.errorMsg,
            },
            ...((formInput.rules ? formInput.rules : []) as Array<any>),
          ]}
        >
          <Input
            style={{ width: '70%', flex: 1 }}
            disabled={formInput.readonly}
            placeholder={formInput.placeholder || 'Enter mobile number'}
          />
        </Form.Item>
      </Input.Group>
    </Form.Item>
  );
};

export default PhoneInput;
